import { render, staticRenderFns } from "./budget-sum-calc-prog-gu-table.vue?vue&type=template&id=379153a6&scoped=true&"
import script from "./budget-sum-calc-prog-gu-table.vue?vue&type=script&lang=ts&"
export * from "./budget-sum-calc-prog-gu-table.vue?vue&type=script&lang=ts&"
import style0 from "./budget-sum-calc-prog-gu-table.vue?vue&type=style&index=0&id=379153a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379153a6",
  null
  
)

export default component.exports